import { Input, InputError, notify, ShowInfo } from '../../utils';
import { FormProvider, useForm } from 'react-hook-form';
import { useState,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFirstInfo } from '../../redux/actions/FirstInfoAction';
import { sendOtp } from '../../../api/MoadianService';
import ValidIranianNationalCode from '../../validation/ValidationIranianNationalCode';
import { Toaster } from 'react-hot-toast';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import 'dayjs/locale/fa';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { ReactComponent as Calender } from "../../../image/CalendarGrey.svg"
import { useNavigate } from "react-router-dom";
import { CalenderIcon } from "../../icons/VectorIcons";


export default function Login({ setGoToPage }) {
    

    const [dateOfBirth, setDateOfBirth] = useState(new Date());
    const [dateOfBirthError, setDateOfBirthError] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    const dispatch = useDispatch();
    const firstInfoFromRedux = useSelector(state => state.FirstInfo)
    const methods = useForm();
    const navigate = useNavigate();

    useEffect(() => {
        if (!firstInfoFromRedux.certType || firstInfoFromRedux.certType == '') {
            navigate('/');
        }
    }, [firstInfoFromRedux.certType]);


    const onSubmit = methods.handleSubmit(data => {

        if (dateOfBirth == null) {
            setDateOfBirthError('لطفا تاریخ تولد خود را وارد کنید.')
        } else {

            setIsSubmitted(true);
            const formattedDate = dateOfBirth.toLocaleDateString('fa-IR-u-nu-latn', {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            });
            if (!firstInfoFromRedux.certType || firstInfoFromRedux.certType == '') {
                notify('لطفا نوع گواهی را انتخاب کنید');
                navigate('/');
                return;
            }

            const firstInfo = {
                "phoneNumber": data.phoneNumber,
                "nationalId": data.nationalId,
                "birthDate": formattedDate.replaceAll("/", ""),
                "certType": firstInfoFromRedux.certType,
            }

            sendOtp(firstInfo).then(response => {
                if (response.data.errorCode === 'OK') {
                    dispatch(setFirstInfo(firstInfo))
                    setIsSubmitted(false)
                    setGoToPage("otp")
                }
            })
                .catch(error => {
                    notify(error?.response?.data?.message)
                    setIsSubmitted(false)
                })
        }
    })

    let year = new Date().toLocaleDateString('fa-IR-u-nu-latn', { year: 'numeric' });
    const optionsDay = [];
    const optionsMonth = [];
    const optionsYear = [];

    for (let i = 1; i <= 30; i++) {
        optionsDay.push({ value: i.toString(), label: ` ${i}` });
    }

    for (let i = 1; i <= 12; i++) {
        optionsMonth.push({ value: i.toString(), label: ` ${i}` });
    }

    for (let i = year; i >= year - 110; i--) {
        optionsYear.push({ value: i.toString(), label: ` ${i}` });
    }

    return (

        <div>
            <Toaster />
            <ShowInfo
                title={'اطلاعات اولیه'}
                message={'لطفا اطلاعات اولیه خود را با دقت وارد نمایید.'}
            />

            <FormProvider {...methods}>
                <form
                    onSubmit={e => e.preventDefault()}
                    noValidate
                    className="container"
                >
                    <Input
                        lable_text={firstInfoFromRedux.certType == 'COMPANY' ? "شماره موبایل نماینده" : "شماره موبایل"}
                        type="number"
                        name="phoneNumber"
                        placeholder="بطور مثال : ۰۹۱۲۳۳۴۵۶۷۸۹"
                        value={firstInfoFromRedux.phoneNumber}
                        validation={{
                            required: {
                                value: true,
                                message: 'لطفا شماره موبایل خود را وارد کنید',
                            },
                            pattern: {
                                value: /^(09)([0-9]){9}$/i,
                                message: 'شماره موبایل شما صحیح نیست'
                            },
                        }}
                    />

                    <Input
                        lable_text={firstInfoFromRedux.certType == 'COMPANY' ? "کد ملی نماینده" : "کد ملی"}
                        type="number"
                        name="nationalId"
                        placeholder="کد ملی ۱۰ رقمی"
                        value={firstInfoFromRedux.nationalId}
                        validation={{
                            required: {
                                value: true,
                                message: 'لطفا کد ملی خود را وارد کنید',
                            },
                            validate: (value) => ValidIranianNationalCode(value) || 'کد ملی شما صحیح نیست',

                        }}
                    />
                    <div className='row justify-content-center mt-1 testing'>
                        <div className='col-12 col-md-5'>

                            <label className="form-label text-form-title"
                            >
                                {firstInfoFromRedux.certType == 'COMPANY' ? "تاریخ تولد نماینده" : "تاریخ تولد"}

                            </label>
                            <span className='required-label'>
                                *
                            </span>
                            <LocalizationProvider dateAdapter={AdapterDateFnsJalali} >
                                <DesktopDatePicker
                                    components={{
                                        openPickerIcon: CalenderIcon,
                                    }}
                                    sx={{ "&.MuiInputBase-root": { borderRadius: "10px", height: "44px", direction: "ltr" } }}
                                    slotProps={{
                                        textField: { fullWidth: true, size: "small", sx: { borderRadius: "10px", "& .MuiInputBase-root": { borderRadius: "10px", height: "44px" } } }
                                    }} value={dateOfBirth}
                                    onChange={(newValue) => setDateOfBirth(newValue)} />
                            </LocalizationProvider>
                            {dateOfBirthError && <InputError show={true} message={dateOfBirthError} />}

                        </div>
                    </div>

                    <div className='row justify-content-center mb-5 mt-5 '>
                        <div className='col-12 col-md-5 d-flex justify-content-between'>
                            <button
                                className='btn border w-100 text-form-title ms-2'
                                onClick={() => navigate('/')}
                            >بازگشت
                            </button>

                            <button
                                onClick={onSubmit}
                                className='btn w-100 text-form-button me-2'
                                style={{ "background": "#044448" }}
                            >ارسال کد
                            </button>

                        </div>
                    </div>
                </form>
            </FormProvider>


            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}

        </div>

    )
}